// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* head bar text color */
@font-face {
  color: #000;
  font-family: Roboto-Black;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Bold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-SemiBold;
  src: url("/assets/fonts/Roboto-Bold.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Light;
  src: url("/assets/fonts/Roboto-Light.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Medium;
  src: url("/assets/fonts/Roboto-Medium.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Regular;
  src: url("/assets/fonts/Roboto-Regular.ttf") format("truetype");
}
@font-face {
  font-family: Roboto-Thin;
  src: url("/assets/fonts/Roboto-Thin.ttf") format("truetype");
}
:host {
  display: block;
}
:host .task-block {
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
}
:host .task-block .task-item {
  width: 40%;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
